/* eslint-disable camelcase */
declare global {
  interface Window {
    exponea:
      | {
          track: (trackType: keyof IMethodDefinition, trackData: IMethodDefinition[keyof IMethodDefinition]) => void;
          showWebLayer: (webLayerId: string) => void;
        }
      | undefined;
    c_ActiveCurrency: string;
    c_UserUuid: string;
  }
}

type IMethodDefinition = {
  banner: ICloseTracking;
  NPSRating: INPSRatingTracking;
};

type ICloseTracking = {
  banner_name: string;
  action: "close";
};

type INPSRatingTracking = {type: string; rating: number; feedback: string};

class Exponea {
  /**
   * public generic exponea track function
   * @param trackType tracking type as string
   * @param trackData tracking data object
   */
  private static track<T extends keyof IMethodDefinition, M extends IMethodDefinition>(
    trackType: T,
    trackData: M[T],
  ): void {
    if (__PRODUCTION__) {
      window.exponea?.track(trackType, trackData);
    }
  }

  public trackNPS(data: INPSRatingTracking): void {
    Exponea.track("NPSRating", {
      type: data.type,
      rating: data.rating,
      feedback: data.feedback,
    });
  }

  public trackClose(bannerName: string): void {
    Exponea.track("banner", {
      action: "close",
      banner_name: bannerName,
    });
  }
}

const exponea = new Exponea();
export {exponea as Exponea};
